import React from 'react';
import { PractitionerRegistrationForm } from '../components/registration/PractitionerRegistrationForm';
export function RegisterPage() {
  return <main className="min-h-screen bg-brand-bg/40 px-4 pb-16 pt-32 sm:px-6 sm:pb-24 sm:pt-36" data-id="element-863">
      <div className="mx-auto max-w-xl" data-id="element-864">
        <PractitionerRegistrationForm data-id="element-865" />
      </div>
    </main>;
}